/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";
import { initBadges } from "components/jiffy/j1-badge/j1-badge-popup/j1-badge-popup";
import { isFlashPdp } from "components/jiffy/product-details/customizable-made-page-utils";

const updateCompositionsBadges = ({ badgesClassName, productIds }) => {
  if (!Array.isArray(productIds)) return;

  const $badges = document.querySelectorAll(badgesClassName);
  const isPresent = id => productIds.includes(parseInt(id, 10));

  if (productIds.length) {
    $badges.forEach(badge => {
      const { compositionId } = badge.dataset;
      badge.classList.toggle("hidden", !isPresent(compositionId));
    });
  } else {
    $badges.forEach(badge => {
      badge.classList.add("hidden");
    });
  }
};

const updateVariantsBadges = ({ badgesClassName, inventory, variantsIds }) => {
  if (!Array.isArray(variantsIds)) return;

  const badges = document.querySelectorAll(badgesClassName);
  const isPresent = id => variantsIds.includes(parseInt(id, 10));

  badges.forEach(badge => {
    const { variantId } = badge.dataset;
    const $input = badge.parentNode.querySelector(".js-quantity-form-input");
    const withBadge = isPresent(variantId) && inventory[variantId] > 0;

    badge.classList.toggle("hidden", !withBadge);
    if ($input && withBadge) {
      $input.classList.add("product-details-quantity-form-row__input--with-badge");
    }
  });
};

const updateCompositionsJ1STBadges = ({ productIds }) => {
  const badges = document.querySelectorAll(".js-jiffy-first-toggle-compositions");
  const colorSelectors = document.querySelectorAll(".js-color-variant-selector");

  colorSelectors.forEach(selector => {
    const { compositionId } = selector.dataset;
    const value = productIds?.indexOf(parseInt(compositionId, 10)) >= 0;
    selector.setAttribute("data-show-j1-badge", `${value}`);
    selector.classList.toggle("product-color-picker__item--jiffy-1st", value);
  });
  badges.forEach(badge => {
    const { compositionId } = badge.dataset;
    badge.classList.toggle("hidden", productIds?.indexOf(parseInt(compositionId, 10)) < 0);
  });
};

const setBadges = () => {
  const {
    basic_low_stock_compositions: basicLowStockCompositions,
    basic_low_stock_variants: basicLowStockVariants,
    inventory: basicInventory
  } = window;
  const inventory = basicInventory;
  if (!inventory) return;

  const setJ1STBadges = () => {
    const {
      basic_jiffy_first_compositions: basicCompositions,
      basic_jiffy_first_variants: basicVariants
    } = window;

    updateVariantsBadges({
      badgesClassName: ".js-jiffy-first-toggle-variants",
      inventory,
      variantsIds: basicVariants
    });
    updateCompositionsJ1STBadges({
      productIds: basicCompositions
    });
  };

  const setAdditionalBadges = () => {
    // low stock badges
    updateCompositionsBadges({
      badgesClassName: ".js-low-stock-toggle-compositions",
      productIds: basicLowStockCompositions
    });
    updateVariantsBadges({
      badgesClassName: ".js-low-stock-toggle-variants",
      inventory,
      variantsIds: basicLowStockVariants
    });
  };

  if (!isFlashPdp()) {
    setJ1STBadges();
  }
  setAdditionalBadges();
  initBadges();
};

export default () => {
  store.pdp.changed((_, { data }) => {
    if (!data.isSettingPDPBadges) return;
    setBadges();
    store.pdp.change({
      isSettingPDPBadges: false,
      activeColor: data.activeColor
    });
  });
  setBadges();
};
